import React, { FC } from 'react';
import { ReactComponent as Notification } from '../../../assets/Notifications/NotificationIcon.svg';

export const NotificationIcon: FC = () => <Notification />;
